import { Component, EventEmitter, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Icon } from '@types-custom/models/ui/icon-model';

@Component({
  selector: 'cdm-manizales-notify-event',
  templateUrl: './notify-event.component.html',
  styleUrls: ['./notify-event.component.scss'],
})
export class NotifyEventComponent {
  props!: any;
  @Output() closeEvent = new EventEmitter<void>();
  @Output() clickEvent = new EventEmitter<void>();

  get Icon() {
    return Icon;
  }

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  close(event: Event) {
    event.stopPropagation();
    this.closeEvent.emit();
  }

  handleClick(info: any) {
    this.clickEvent.emit(info);
  }

  getFormattedText(text: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }
}
